export const mensajesChat = {
  // NewConversationModal.vue — start a new WhatsApp conversation
  newConversation: {
    nameTooShort: "Digite o nome pelo qual você quer ser reconhecido.",
    saveNameError: "Não foi possível salvar o nome da empresa.",
    started: "Conversa iniciada.",
    sent: "Mensagem enviada.",
    startError: "Não foi possível iniciar a conversa.",
    titleConnect: "Conecte seu WhatsApp",
    titleName: "O nome da sua empresa",
    titleNew: "Nova conversa",
    subtitleConnect: "Necessário para você poder enviar mensagem primeiro",
    subtitleName: "Este é o nome que as pessoas verão como remetente da mensagem",
    subtitleNew: "Envie mensagem para qualquer número no WhatsApp",
    close: "Fechar",
    senderStripPre: "Será enviado como",
    change: "Alterar",
    connectBody:
      "Para enviar mensagem primeiro, a mensagem precisa vir do <strong>seu próprio número do WhatsApp Business</strong>. Com o número compartilhado da WACheckin, as pessoas veriam um telefone que não é o seu, e não poderíamos apresentá-lo com o nome da sua empresa.",
    connectItem1: "Envie mensagem para qualquer número, com ou sem reserva",
    connectItem2: "O nome da sua empresa aparece como remetente",
    connectItem3: "As respostas chegam nesta mesma caixa de entrada",
    connectFoot: "Conecte uma vez, em Integrações → WhatsApp.",
    previewLabel: "Como eles verão",
    previewGreeting: "Oi 👋",
    previewFromPre: "Enviamos esta mensagem em nome de",
    previewFromPost: ".",
    previewCtaPre: "Temos uma mensagem para você. Responda",
    previewOk: "Ok",
    previewCtaPost: "e nós a enviaremos.",
    fallbackBusiness: "sua empresa",
    nameLabel: "Nome da empresa",
    namePlaceholder: "Pousada Nascer do Sol",
    nameHelp:
      "Ele é salvo em Agente de IA → Novas reservas, e você pode alterá-lo lá ou aqui quando quiser.",
    recipientLabel: "Destinatário",
    messageLabel: "Mensagem",
    messagePlaceholder: "Escreva sua mensagem…",
    cancelSoft: "Agora não",
    cancel: "Cancelar",
    connectBtn: "Conectar o WhatsApp",
    continueBtn: "Continuar",
    sendBtn: "Enviar mensagem",
  },

  // MessageTranslate.vue — per-message translation in chat bubbles
  translate: {
    // BarraTraduccion.vue — a barra do tradutor do chat (automático + prévia)
    off: "Tradução automática desligada",
    on: "Traduzindo",
    turnOn: "Traduzir o que chega e ver antes o que você escreve",
    turnOff: "Desligar a tradução automática",
    guestWrites: "o hóspede escreve em {idioma}",
    nothingToDo: "Nada para traduzir: o hóspede escreve em {idioma}",
    youRead: "Você lê em",
    willBeSentIn: "o que você escrever será enviado em",
    pickOutgoing: "Em que idioma vai chegar para ele",
    theirs: "o dele",
    willArriveAs: "Vai chegar assim, em {idioma}:",
    sendIn: "Enviar em {idioma}",
    cancel: "Cancelar",
    discard: "Descartar",
    enterSends: "Com Enter vai",
    translating: "Traduzindo…",
    translate: "Traduzir",
    viewTranslation: "Ver tradução",
    viewOriginal: "Ver original",
    translated: "Traduzido",
    copy: "Copiar",
    copied: "Copiado",
    error: "Não foi possível traduzir. Tente novamente.",
  },

  // Phone.vue — WhatsApp-style chatbot preview
  phone: {
    online: "Online",
    today: "Hoje",
    sampleQuestion: "A que horas é o check-in?",
    answerPlaceholder: "Escreva sua resposta aqui...",
    inputPlaceholder: "Digite uma mensagem...",
  },

  // selectorTypeIframe.vue — subscription billing period selector
  billing: {
    selectPeriod: "Escolha um período",
    selectPeriodHint: "Escolha como você quer pagar",
    monthly: "Mensal",
    annual: "Anual",
  },

  // GrupoDestinatarios.vue — escribir a un grupo de huéspedes
  grupo: {
    modeLabel: "Para quem escreves",
    modeOne: "Mensagem normal",
    modeGroup: "Mensagem em massa",
    allOtas: "Todas",
    needsWhatsapp: "Liga o teu WhatsApp para usar esta via",
    connectNow: "Ligar",
    varsLabel: "Variável",
    vars: {
      nombre: "O nome do hóspede",
      alojamiento: "O nome do alojamento",
      entrada: "A data de entrada",
      salida: "A data de saída",
      codigo: "O código da reserva",
    },
    remove: "Remover",
    oneEach: "Cada hóspede recebe uma só vez, pela primeira via disponível.",
    noContact: "1 sem forma de contacto | {count} sem forma de contacto",
    otaLabel: "Que OTA",
    emoji: "Emoji",
    attach: "Anexar ficheiro",
    noFileOta: "O ficheiro não viaja pela OTA",
    previewLabel: "Como vai ler-se",
    fileTooBig: "«{name}» pesa {size} MB e o máximo do WhatsApp para este tipo é {max} MB",
    fileNotAllowed: "Só se admitem imagens (JPG, PNG, GIF), PDF e vídeo MP4: o WhatsApp não reproduz outros formatos.",
    attachHint: "Imagens e PDF até 10 MB · vídeo MP4 até 15 MB",
    channelLabel: "Por onde",
    channels: { whatsapp: "WhatsApp", email: "E-mail", ota: "OTA" },
    groupLabel: "Que hóspedes",
    groups: {
      alojados: "Hospedados agora",
      entran_hoy: "Chegam hoje",
      entran: "Chegam em breve",
      salen: "Saem hoje",
    },
    withinPre: "nos próximos",
    withinPost: "dia | dias",
    empty: "Não há hóspedes neste grupo neste momento.",
    reachOf: "de {total} vai recebê-la | de {total} vão recebê-la",
    queuedSilently: "1 não recebe aviso hoje: já tinha um pendente | {count} não recebem aviso hoje: já tinham um pendente",
    noChannel: {
      whatsapp: "1 sem telefone | {count} sem telefone",
      email: "1 sem e-mail | {count} sem e-mail",
      ota: "1 sem conversa de OTA | {count} sem conversa de OTA",
    },
    billed: "1 conversa de WhatsApp é cobrada | {count} conversas de WhatsApp são cobradas",
    showList: "Ver o destinatário | Ver os {count} destinatários",
    hideList: "Ocultar a lista",
    noName: "Sem nome",
    states: {
      directo: "chega",
      plantilla: "convite",
      en_cola: "já tinha um pendente",
      sin_telefono: "sem telefone",
      sin_correo: "sem e-mail",
      sin_hilo_ota: "sem conversa",
      sin_contacto: "sem contacto",
    },
    sending: "A enviar a 1 hóspede | A enviar a {count} hóspedes",
    sendGroup: "Enviar a 1 hóspede | Enviar a {count} hóspedes",
    historial: {
      providerId: "Identificador do fornecedor. Com ele procura-se a mensagem na consola do SES.",
      sentMeans: "«Saiu» quer dizer que o fornecedor o aceitou. Que o hóspede o leia, ou que não acabe no lixo eletrónico, já não depende de nós.",
      estados: {
        enviando: "A sair",
        enviado: "Saiu",
        en_cola: "Em fila",
        fallo: "Não saiu",
        sin_contacto: "Sem forma de contacto",
      },
      title: "Envios a grupos",
      subtitle: "O que se mandou, a quem e o que aconteceu com cada um",
      empty: "Ainda não mandou nenhuma mensagem a um grupo.",
      error: "Não foi possível carregar o histórico.",
      sentBy: "por {quien}",
      running: "Em curso",
      back: "Voltar",
      messageLabel: "A mensagem",
      recipientsLabel: "Destinatários",
      colName: "Hóspede",
      colVia: "Por onde",
      colDest: "Para onde",
      colState: "O que aconteceu",
      openChat: "Abrir",
      attachment: "Anexo: {nombre}",
      close: "Fechar",
      reached: "{enviados} de {total}",
      noOne: "Sem nome",
    },
  },
};
